import { useEffect, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { GlobalDialog } from "./GlobalDialog";
import { LockScreen } from "@/ui/components/LockScreen";
import { Toaster } from "@/ui/components/ui/toaster";
import { setNavigate } from "@/services/module_api";
import { appNavigation } from "@/utils/module_api";
import { RecoveryStatusBanner } from "@/features/recovery/RecoveryStatusBanner";

export function AppLayout() {
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  // Set the navigate function for use outside of React components
  useEffect(() => {
    // Set for router effect
    setNavigate(navigate);
    // Set for appServices
    appNavigation.setNavigate(navigate, goBack);
  }, [navigate, goBack]);

  return (
    <div data-name="app-layout" className="h-screen flex flex-col bg-background">
      <RecoveryStatusBanner />
      <Outlet />
      <Toaster />
      <GlobalDialog />
      <LockScreen />
    </div>
  );
}
